'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'

import { TabsListVariantContext } from '~/components/component-library/Tabs/context'
import {
  TABS_LIST_CLASSNAME,
  TABS_LIST_DENSE_RULE_CLASSNAME,
  TABS_LIST_TABLE_FRAME_CLASSNAME,
} from '~/components/component-library/Tabs/styles'
import { type TabsListProps } from '~/components/component-library/Tabs/types'
import { cn } from '~/utils/tailwind-utils'

export const TabsList = ({
  ref,
  variant = 'default',
  className,
  ...props
}: TabsListProps) => {
  const list = (
    <TabsPrimitive.List
      ref={ref}
      className={cn(TABS_LIST_CLASSNAME[variant], className)}
      {...props}
    />
  )

  const wrapped =
    variant === 'table' ? (
      <div className={TABS_LIST_TABLE_FRAME_CLASSNAME}>{list}</div>
    ) : variant === 'dense' ? (
      <>
        {list}
        <div className={TABS_LIST_DENSE_RULE_CLASSNAME} />
      </>
    ) : (
      list
    )

  return (
    <TabsListVariantContext value={variant}>{wrapped}</TabsListVariantContext>
  )
}
